import React from 'react'
import { Dropdown } from 'react-bootstrap'

import useTranslation from '@/Hooks/UseTranslation'

interface Props {
  disabled?: boolean
  importDisabled?: boolean
  onCreateGroup: () => void
  onCreateTask: () => void
  onImport: () => void
}

const ProgrammationCreateMenu = ({
  disabled = false,
  importDisabled = false,
  onCreateGroup,
  onCreateTask,
  onImport,
}: Props) => {

  const { t } = useTranslation()

  return (
    <Dropdown className="pl4-programmation-create-menu">
      <Dropdown.Toggle
        as="button"
        type="button"
        disabled={disabled}
        className="btn btn-link btn-link-header pl4-programmation-action pl4-page-action--primary pl4-programmation-action--primary"
        aria-label={t('MACRO:ToolbarNewButton')}
        title={t('MACRO:ToolbarNewButton')}
      >
        <i className="fas fa-plus" aria-hidden="true" />
        <span className="d-none d-sm-inline">{t('MACRO:ToolbarNewButton')}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu alignRight className="pl4-programmation-create-menu__menu">
        <Dropdown.Item
          as="button"
          className="pl4-programmation-create-menu__item pl4-programmation-create-menu__item--primary"
          onClick={onCreateTask}
        >
          <span className="icon-agregar_tarea" aria-hidden="true" />
          <span>{t('MACRO:ToolbarCreateTaskButton')}</span>
        </Dropdown.Item>
        <Dropdown.Item
          as="button"
          className="pl4-programmation-create-menu__item"
          onClick={onCreateGroup}
        >
          <span className="icon-agregar_grupo_tareas" aria-hidden="true" />
          <span>{t('MACRO:ToolbarCreateGroupButton')}</span>
        </Dropdown.Item>
        <Dropdown.Divider />
        <Dropdown.Item
          as="button"
          className="pl4-programmation-create-menu__item"
          disabled={importDisabled}
          onClick={onImport}
        >
          <span className="icon-agregar_tarea" aria-hidden="true" />
          <span>{t('MACRO:ToolbarImportButton')}</span>
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

export default ProgrammationCreateMenu
